
import { Coins, Gift } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTokens } from "@/hooks/use-tokens";
import { useNavigate } from "react-router-dom";

interface TokenBalanceProps {
  showDonationButton?: boolean;
  className?: string;
}

export const TokenBalance = ({ showDonationButton = false, className }: TokenBalanceProps) => {
  const { tokens, isLoading, claimDailyTokens, canClaimDailyTokens } = useTokens();
  const navigate = useNavigate();

  const handleDonation = () => {
    navigate('/donation');
  };

  const handleClaimDailyTokens = async () => {
    await claimDailyTokens();
  };

  if (isLoading) {
    return (
      <Card className={className}>
        <CardContent className="flex items-center justify-center p-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Coins className="h-5 w-5 text-yellow-500" />
          Mes Tokens
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold text-primary">{tokens}</span>
            <span className="text-sm text-muted-foreground">tokens disponibles</span>
          </div>
          <div className="flex gap-2">
            {canClaimDailyTokens && (
              <Button 
                onClick={handleClaimDailyTokens}
                size="sm"
                variant="outline"
                className="flex items-center gap-2 bg-green-50 hover:bg-green-100 text-green-700 border-green-200"
              >
                <Gift className="h-4 w-4" />
                3 tokens gratuits
              </Button>
            )}
            {showDonationButton && (
              <Button 
                onClick={handleDonation}
                size="sm"
                variant="outline"
                className="flex items-center gap-2"
              >
                <Gift className="h-4 w-4" />
                Faire un don
              </Button>
            )}
          </div>
        </div>
        {tokens === 0 && (
          <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-md">
            <p className="text-sm text-orange-800">
              Vous n'avez plus de tokens. Réclamez vos 3 tokens gratuits quotidiens ou faites un don pour continuer à utiliser l'assistant IA !
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
